import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from './BaseComponent';

class Element extends BaseComponent {
    componentDidUpdate() {
        this.updeteDocumentElement();
    }

    componentDidMount() {
        this.updeteDocumentElement();
    }

    updeteDocumentElement() {
        const { item = {} } = this.props;
        if (item && item.content) {
            $(this.wrapper)
                .empty()
                .append(item.content);
        }
    }

    render() {
        return (
            <div
                ref={(dom) => {
                    this.wrapper = dom;
                }}
            >
                Element
            </div>
        );
    }
}

Element.displayName = 'Element';
Element.propTypes = {};

export default Element;



// WEBPACK FOOTER //
// ./components/ModalSet/Element.js